import { SVGProps } from "react";

const CloudUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9440_498386)">
      <path
        d="M11.669 30C9.5895 30 7.59513 29.2098 6.12467 27.8033C4.65422 26.3968 3.82812 24.4891 3.82812 22.5C3.82812 20.5109 4.65422 18.6032 6.12467 17.1967C7.59513 15.7902 9.5895 15 11.669 15C12.1602 12.812 13.597 10.8891 15.6633 9.65452C16.6865 9.04321 17.8334 8.61925 19.0387 8.40685C20.2439 8.19446 21.4838 8.1978 22.6876 8.41667C23.8913 8.63554 25.0354 9.06566 26.0545 9.68247C27.0736 10.2993 27.9477 11.0907 28.627 12.0115C29.3062 12.9324 29.7773 13.9646 30.0133 15.0493C30.2493 16.134 30.2456 17.2499 30.0024 18.3333H31.669C33.2161 18.3333 34.6999 18.9479 35.7938 20.0419C36.8878 21.1358 37.5024 22.6196 37.5024 24.1667C37.5024 25.7138 36.8878 27.1975 35.7938 28.2915C34.6999 29.3854 33.2161 30 31.669 30H30.0024"
        stroke="#1C1C1C"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 25L20 20L25 25"
        stroke="#1C1C1C"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 20V35"
        stroke="#1C1C1C"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9440_498386">
        <rect width={40} height={40} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CloudUpload;
